import React from 'react';
import { connect } from 'react-redux';
import withRouter from 'js/withRouter';
import Modal from 'components/Modal';

import { legacyInjectIntl } from 'js/wrapper/injectIntl';

import Data from 'components/Data';
import CmsPage from 'components/CmsPage';

import Loader from 'components/layout/Loader';

// display terms and conditions of current platform
class ModalMasterTermsOfService extends React.Component {
  render() {
    const {
      intl: { messages },
      show,
      close,
      cmsPage,
    } = this.props;

    return (
      <Modal show={show} onHide={close} size="lg" className="full-width">
        <Modal.Header closeButton>
          <Modal.Title>{messages.terms_of_service}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Data dataName="cmsSystemPageTermsOfService" url="/api/pages/termsofservice.json" data={cmsPage} />

          <div className="themed">
            {cmsPage.pending ? <Loader /> : <CmsPage data={cmsPage.data} doUpdateActiveCms={false} />}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    cmsPage: state.data.cmsSystemPageTermsOfService,
  };
};

export default withRouter(legacyInjectIntl(connect(mapStateToProps)(ModalMasterTermsOfService)));
